import { Product, ProductPrice } from 'src/app/core/services/billing.service';

export const environment = {
  production: false,
  appVersion: require('../../package.json').version + '-dev',
  heapAppId: '4104449956',
  intercomAppId: 'jvtkde6p',
  moneyballSubscriptionPriceId: 'price_1QGBO2KjCB7MuRGZxaXj7T3W',
  moneyballSubscriptionProductId: 'prod_R8SIfU7wz3vkfN',
  peopleSubscriptionProductId: 'prod_S8BHDYoFl00uiW',
  // Workforce.ai (chat) subscription — staging Stripe product/prices from the billing manifest.yml.
  chatSubscriptionProductId: 'prod_UeLKty377lgh17',
  chatProSubscriptionPriceId: 'price_1Tf2dYKjCB7MuRGZHtTXdohk',
  chatTeamSubscriptionPriceId: 'price_1Tf2dYKjCB7MuRGZ1mpb0qTD',
  ledgerApiBasePathV2: 'https://staging.gotlivedata.io/api/ledger/v2',
  identityApiBasePath: 'https://staging.gotlivedata.io/api/identity/v1',
  cleanApiBasePath: 'https://staging.gotlivedata.io/api/clean/v2',
  onboardingApiBasePath: 'https://staging.gotlivedata.io/api/onboarding/v1',
  billingApiBasePath: 'https://staging.gotlivedata.io/api/billing/v1',
  dwReaderApiBasePath: 'https://staging.gotlivedata.io/api/dw/v1',
  growApiBasePath: 'https://gotlivedata.io/api/grow',
  devDeploysApiBasePath: 'https://staging.gotlivedata.io/api/dynamo/v1',
  moneyballApiBasePath: 'https://staging.gotlivedata.io/api/moneyball/v1',
  peopleApiBasePath: 'https://staging.gotlivedata.io/api/people/v1',
  chatApiBasePath: 'https://staging.gotlivedata.io/api/chat/v1',
  dataDeliveryApiBasePath:
    'https://deliveries.dwh-pipeline.staging.gotlivedata.io/api/deliveries/v1',
  resolverApiBasePath: 'https://resolver.dwh-pipeline.staging.gotlivedata.io/api/resolver/v1',
  GCS_DESTINATION_TYPE_ID: 8,
  SNOWFLAKE_DESTINATION_TYPE_ID: 5,
  stateStorageApiBasePath: 'https://dw.dwh-pipeline.staging.gotlivedata.io/api/state_storage/v1',
  providersApiBasePath: 'https://staging.gotlivedata.io/api/providers/v1',
  tasksApiBasePath: 'https://staging.gotlivedata.io/api/tasks/v1',
  recaptchaV3SiteKey: '6LcUCkMeAAAAAChgVW3JuwaqVulc6BK6c7RymQGC',
  onboardingNotificationURL: 'https://b00e517e99e95689512dd34120cbcde2.m.pipedream.net',
  googleAuthClientId: '497055724954-nc1nsh88tqrqvdp8a91j22a26mtge1bo.apps.googleusercontent.com',
  googleSheetsClientId: '548405968375-2thi10dnf9t72rqdmscri5g1i7c9qc0c.apps.googleusercontent.com', // TODO: Replace with your OAuth Client ID
  microsoftAuthClientId: '41a79198-1b33-44e7-b555-5ea00923f88c',
  flatfileEnvironmentId: 'us_env_EKCwtluk',
  flatfilePublishableKey: 'pk_004517c97ff14c9eae380b4bcf74ae4a',
  providerIntakeApiBasePath: 'https://staging.gotlivedata.io/api/providerintake',
  chatProtoApiBasePath: 'https://wkhlw1b9b1.execute-api.us-east-1.amazonaws.com/',
};

export const customerProducts: Product[] = [
  {
    id: 'prod_S8BHDYoFl00uiW',
    prices: [
      {
        priceId: 'price_1RPVAgKjCB7MuRGZ3JlfcAyh',
        price: 1299,
        qty: 50000,
      },
      {
        priceId: 'price_1SoqarKjCB7MuRGZXQzlhgS1',
        price: 1999,
        qty: 100000,
      },
      {
        priceId: 'price_1Soqb2KjCB7MuRGZk553Ds5T',
        price: 2999,
        qty: 200000,
      },
    ],
  },
];

// Retired People Data tiers: no longer purchasable, kept so existing
// subscriptions on these prices still render (admin org details lookup).
export const retiredPeoplePrices: ProductPrice[] = [
  { priceId: 'price_1RDwvUKjCB7MuRGZaauu3TIC', price: 99, qty: 2000 },
  { priceId: 'price_1RDwvhKjCB7MuRGZ5YlWpZNX', price: 199, qty: 5000 },
  { priceId: 'price_1RDwvnKjCB7MuRGZDXgvhFCy', price: 349, qty: 10000 },
  { priceId: 'price_1RPVAZKjCB7MuRGZrH7uiawU', price: 599, qty: 20000 },
];
